import { PreferenceStore } from 'src/js/store/preference-store';
import { SessionStore } from 'src/js/store/session-store';
import { StreamListExpansionStore } from 'src/js/store/stream-list-expansion-store';

/**
 * List ALL the stores here.
 */
const sessionStore: SessionStore = new SessionStore();
const preferenceStore: PreferenceStore = new PreferenceStore();
const streamExpansionStore: StreamListExpansionStore = new StreamListExpansionStore();

/**
 * Export ALL persisted stores here.
 */
export const persistedStores = {
  // TODO: Move those into a single provider
  sessionStore,
  preferenceStore,
  streamExpansionStore,
};

/**
 * Export ALL the stores here.
 */
export const globalStores = {
  ...persistedStores,
};
